export default __webpack_public_path__ + "static/media/entry.65bae959.svg";